import { render } from "./LandingPage.vue?vue&type=template&id=562aa43c"
const script = {}

import "./LandingPage.vue?vue&type=style&index=0&id=562aa43c&lang=scss"

import exportComponent from "D:\\DOWNLOAD\\vue\\portfolio_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__